import questionTypesMap from '@/store/question-types-map'
import * as util from '@/library/util'
import _ from 'lodash'
import { addressSkins, addressSkinIds, addressAutocompleteModes, dateSkins, dateSkinIds, paymentSkinIds, paymentSkins, rangeSkinIds, rangeSkins, npsSkins, npsScale, signatureSkinIds, signatureSkins, yesNoSkins, yesNoSkinIds } from '@/shared/constants/formQuestionSkins'
import { createDefaultPaymentProduct, PAYMENT_DEFAULTS } from '@/shared/constants/payment'

export default [
  {
    'type': questionTypesMap.FIRST_NAME,
    'question': 'What is your first name?',
    'label': 'First Name',
    'fa_icon': 'fa fa-file-text',
    'material_icon': 'note',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': 'first_name',
    'hide_title': true,
    'state': ['Is Equal To', 'Is Not Equal To', 'Contains', 'Does Not Contain', 'Starts With', 'Doesn’t Start With', 'Ends With', 'Doesn’t End With', 'Is Empty', 'Is Filled'],
    'options': {
      placeholder: true,
      placeholderText: '',
      require: true
    }
  },

  {
    'type': questionTypesMap.LAST_NAME,
    'question': 'What is your last name?',
    'label': 'Last Name',
    'fa_icon': 'fa fa-file-text',
    'material_icon': 'note',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': 'last_name',
    'hide_title': true,
    'state': ['Is Equal To', 'Is Not Equal To', 'Contains', 'Does Not Contain', 'Starts With', 'Doesn’t Start With', 'Ends With', 'Doesn’t End With', 'Is Empty', 'Is Filled'],
    'options': {
      placeholder: true,
      placeholderText: '',
      require: true
    }
  },

  {
    'type': questionTypesMap.SHORT_TEXT,
    'question': '',
    'label': 'Short Text',
    'fa_icon': 'fa fa-file-text',
    'material_icon': 'note',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': 'short_text',
    'hide_title': true,
    'state': ['Is Equal To', 'Is Not Equal To', 'Contains', 'Does Not Contain', 'Starts With', 'Doesn’t Start With', 'Ends With', 'Doesn’t End With', 'Is Empty', 'Is Filled'],
    'options': {
      placeholder: true,
      placeholderText: '',
      require: true
    }
  },

  {
    'type': questionTypesMap.PARAGRAPH_TEXT,
    'question': '',
    'label': 'Paragraph Text',
    'fa_icon': 'fa fa-paragraph',
    'material_icon': 'assignment',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': 'long_text',
    'hide_title': true,
    'state': ['Is Equal To', 'Is Not Equal To', 'Contains', 'Does Not Contain', 'Starts With', 'Doesn’t Start With', 'Ends With', 'Doesn’t End With', 'Is Empty', 'Is Filled'],
    'options': {
      placeholder: true,
      placeholderText: '',
      require: true
    }
  },

  {
    'type': questionTypesMap.EMAIL_ADDRESS,
    'question': 'What is your email address?',
    'label': 'Email Address',
    'fa_icon': 'fa fa-envelope',
    'material_icon': 'email',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': 'email',
    'hide_title': true,
    'state': ['Is Equal To', 'Is Not Equal To', 'Contains', 'Does Not Contain', 'Starts With', 'Doesn’t Start With', 'Ends With', 'Doesn’t End With', 'Is Empty', 'Is Filled'],
    'options': {
      placeholder: true,
      placeholderText: '',
      require: true,
      replyTo: false,
      emailVerification: false,
      restrictEmail: false,
      restrictEmailFields: [
        {id: 1, email: '', order: 1, allow: 1}
      ]
    }
  },

  {
    'type': questionTypesMap.PHONE_NUMBER,
    'question': 'What is your phone number?',
    'label': 'Phone Number',
    'fa_icon': 'fa fa-phone',
    'material_icon': 'phone',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': 'phone',
    'hide_title': true,
    'state': ['Is Empty', 'Is Filled'],
    'options': {
      placeholder: true,
      placeholderText: '',
      require: true,
      defaultCountryCode: null,
      enableDefaultCode: false
    }
  },
  {
    'type': questionTypesMap.DATE,
    'question': 'What is your date of birth?',
    'label': 'Date',
    'fa_icon': 'fa fa-date',
    'material_icon': 'date',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': '',
    'skin': _.find(dateSkins, {id: dateSkinIds.THREE_INPUT_BOXES}),
    'hide_title': true,
    'state': ['Is Equal To Date', 'Is Not Equal To Date', 'Before', 'After', 'Is Empty', 'Is Filled'],
    'options': {
      placeholder: true,
      placeholderDayText: '',
      placeholderMonthText: '',
      placeholderYearText: '',
      require: true,
      minDate: null,
      maxDate: null,
      enableMinMax: false,
      autoIncrement: false,
      skins: dateSkins
    }
  },

  {
    'type': questionTypesMap.SINGLE_CHOICE,
    'question': '',
    'label': 'Single Select (Choose One Option)',
    'fa_icon': 'fa fa-list',
    'material_icon': 'list',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': 'choice_question',
    'skin': util.singleSelectSkins()[0],
    'hide_title': true,
    'state': ['Is Equal To', 'Is Not Equal To', 'Is Empty', 'Is Filled'],
    'nonQualifyingSettings': { enabled: true, message: '', fullScreen: false },
    'options': {
      placeholder: true,
      require: true,
      choices: [
        {id: 1, label: 'Choice 1', order: 1, description: '', icon: '', image: '', selected: false, nonQualifying: false},
        {id: 2, label: 'Choice 2', order: 2, description: '', icon: '', image: '', selected: false, nonQualifying: false},
        {id: 3, label: 'Choice 3', order: 3, description: '', icon: '', image: '', selected: false, nonQualifying: false}
      ],
      choicesValues: [0, 0, 0],
      enableChoicesValues: false,
      enablePreSelectChoices: false,
      randomChoiceOrder: false,
      skins: util.singleSelectSkins(),
      otherOption: ''
    }
  },

  {
    'type': questionTypesMap.MULTIPLE_CHOICE,
    'question': '',
    'label': 'Multi Select (Choose One Or More Options)',
    'fa_icon': 'fa fa-list',
    'material_icon': 'list',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': 'choice_question2',
    'skin': util.multiSelectSkins()[0],
    'hide_title': true,
    'state': ['Is Equal To', 'Is Not Equal To', 'Is Empty', 'Is Filled'],
    'nonQualifyingSettings': { enabled: true, message: '', fullScreen: false },
    'options': {
      placeholder: true,
      require: true,
      choices: [
        {id: 1, label: 'Choice 1', order: 1, description: '', icon: '', image: '', selected: false, nonQualifying: false},
        {id: 2, label: 'Choice 2', order: 2, description: '', icon: '', image: '', selected: false, nonQualifying: false},
        {id: 3, label: 'Choice 3', order: 3, description: '', icon: '', image: '', selected: false, nonQualifying: false}
      ],
      choicesValues: [0, 0, 0],
      enableMinMaxChoices: false,
      minChoices: 1,
      maxChoices: 1,
      enableChoicesValues: false,
      enablePreSelectChoices: false,
      randomChoiceOrder: false,
      skins: util.multiSelectSkins(),
      otherOption: ''
    }
  },

  {
    type: questionTypesMap.ADDRESS,
    question: 'What is your home address?',
    label: 'Address',
    fa_icon: 'fa fa-list',
    material_icon: 'list',
    description: '',
    hover_text: '',
    hover_text_position: 'left',
    field_name: 'address',
    hide_title: true,
    skin: _.find(addressSkins, {id: addressSkinIds.DEFAULT}),
    skins: addressSkins,
    autocompleteApiKeySource: '',
    autocompleteApiKey: '',
    autocompleteMode: addressAutocompleteModes[0],
    autocompleteFieldsEdit: false,
    state: ['Country Equals', 'Country Doesnt Equals', 'State Equals', 'State Dosent Equals'],
    required: true,
    fields: {
      address_line_2: {
        id: 'address_line_2',
        enabled: true,
        required: true,
        label: 'Address Line 2',
        label_value: '',
        placeholder: 'Address Line 2',
        placeholder_value: 'Address Line 2',
        field_name: '',
        field_name_suffix: 'line_2',
        webhook: false,
        order: 1
      },
      address_line_1: {
        id: 'address_line_1',
        enabled: true,
        required: true,
        label: 'Address Line 1',
        label_value: '',
        placeholder: 'Address Line 1',
        placeholder_value: 'Address Line 1',
        field_name: '',
        field_name_suffix: 'line_1',
        webhook: false,
        order: 2
      },
      city: {
        id: 'city',
        enabled: true,
        required: true,
        label: 'Town/City',
        label_value: '',
        placeholder: 'Town/City',
        placeholder_value: 'Town/City',
        field_name: '',
        field_name_suffix: 'city',
        webhook: false,
        auto_complete: false,
        order: 3
      },
      state: {
        id: 'state',
        enabled: true,
        required: true,
        label: 'State',
        label_value: '',
        placeholder: 'State',
        placeholder_value: 'State',
        field_name: '',
        field_name_suffix: 'state',
        webhook: false,
        auto_complete: true,
        order: 4
      },
      country: {
        id: 'country',
        enabled: true,
        required: true,
        label: 'Country',
        label_value: '',
        placeholder: 'Country',
        placeholder_value: 'Country',
        field_name: '',
        field_name_suffix: 'country',
        webhook: false,
        auto_complete: true,
        order: 5
      },
      post_code: {
        id: 'post_code',
        enabled: false,
        required: true,
        label: 'Postal Code / Zip Code',
        label_value: '',
        placeholder: 'Zip Code field',
        placeholder_value: 'Post Code',
        field_name: '',
        field_name_suffix: 'post_code',
        webhook: false,
        order: 6
      },
      landmark: {
        id: 'landmark',
        enabled: false,
        required: true,
        label: 'Landmark',
        label_value: '',
        placeholder: 'Landmark',
        placeholder_value: 'Landmark',
        field_name: '',
        field_name_suffix: 'landmark',
        webhook: false,
        order: 7
      }
    }
  },
  {
    type: questionTypesMap.GDPR,
    label: 'Marketing permissions',
    title: 'Marketing permissions',
    description: 'We will use the information you provide on this form to be in touch with you and to provide updates and marketing. Please let us know all the ways you like to hear from us.',
    hover_text: '',
    hover_text_position: 'left',
    field_name: 'gdpr',
    hide_title: true,
    'state': ['Is Checked', 'Is Not Checked'],
    options: {
      choices: [{
        id: 1,
        label: 'I agree to receive marketing communications by email',
        required: false
      }, {
        id: 2,
        label: 'I agree to receive marketing communications by phone',
        required: false
      }]
    },
    required: false,
    enabled: true
  },
  {
    type: questionTypesMap.CONSENT_PRIVACY,
    label: 'Consent & Privacy',
    title: 'Consent & Privacy',
    description: 'How we use your information. We will use the details you provide to respond to your enquiry and to deliver the services you have requested. For full details on how we handle your data, please read our Privacy Policy.',
    hover_text: '',
    hover_text_position: 'left',
    field_name: 'consent_privacy',
    hide_title: false,
    'state': ['Is Checked', 'Is Not Checked'],
    options: {
      choices: [{
        id: 1,
        label: 'I agree to receive marketing communications. We’d like to send you updates about our products, services, and offers. You can withdraw this consent at any time.',
        required: false
      }, {
        id: 2,
        label: 'I acknowledge the Privacy Policy. I confirm I have read and understood how my personal data will be collected, stored, and used in accordance with your privacy policy.',
        required: false
      }]
    },
    required: false,
    enabled: true
  },
  {
    'type': questionTypesMap.NUMBER,
    'question': '',
    'label': 'Number',
    'fa_icon': 'fa fa-phone',
    'material_icon': 'phone',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': 'number',
    'hide_title': true,
    'state': ['Is Equal To', 'Is Not Equal To', 'Greater Than', 'Less Than', 'Is Empty', 'Is Filled'],
    'options': {
      placeholder: true,
      placeholderText: '',
      enableMinMaxLimit: false,
      require: true,
      minNumber: null,
      maxNumber: null
    }
  },
  {
    'type': questionTypesMap.URL,
    'question': 'What is your website URL?',
    'label': 'Website',
    'fa_icon': 'fa fa-link',
    'material_icon': 'link',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': 'website',
    'hide_title': true,
    'state': ['Is Equal To', 'Is Not Equal To', 'Contains', 'Does Not Contain', 'Is Empty', 'Is Filled'],
    'options': {
      placeholder: true,
      placeholderText: 'https://',
      require: true
    }
  },
  {
    'type': questionTypesMap.RANGE,
    'question': '',
    'label': 'Scale',
    'fa_icon': 'fa fa-scale',
    'material_icon': 'linear_scale',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': '',
    'skin': _.find(rangeSkins, {id: rangeSkinIds.SLIDER_SCALE}),
    'hide_title': true,
    'state': ['Is Equal To', 'Is Not Equal To', 'Greater Than', 'Less Than', 'Is Empty', 'Is Filled'],
    'options': {
      placeholder: true,
      placeholderText: '',
      require: true,
      enableCustomText: false,
      enableUnitValues: false,
      enableStepCount: false,
      showHideOrientationScale: true,
      rangeFields: {
        unitAlignment: 'left',
        unit: '',
        stepCount: '',
        veryUnsatisfied: 'Very Unsatisfied',
        unsatisfied: 'Unsatisfied',
        neutral: 'Neutral',
        satisfied: 'Satisfied',
        verySatisfied: 'Very Satisfied',
        lowerEndScaleText: 'Very Bad',
        higherEndScaleText: 'Excellent',
        maxScaleLimit: 5,
        minScaleValue: 0,
        maxScaleValue: 100,
        valueMin: 0,
        valueMax: 100,
        likertRadios: [
          {id: 0, label: '1', lowerEndScaleText: 'Very Bad'},
          {id: 1, label: '2'},
          {id: 2, label: '3'},
          {id: 3, label: '4'},
          {id: 4, label: '5', higherEndScaleText: 'Excellent'}
        ]
      },
      skins: rangeSkins
    }
  },
  {
    // Own type (not a RANGE skin) so NPS answers stay separate and it can be limited to one per form
    'type': questionTypesMap.NPS,
    'question': 'How likely are you to recommend us to a friend or colleague?',
    'label': 'NPS',
    'fa_icon': 'fa fa-line-chart',
    'material_icon': 'trending_up',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': '',
    'skin': npsSkins[0],
    'hide_title': true,
    'state': ['Is Equal To', 'Is Not Equal To', 'Greater Than', 'Less Than', 'Is Empty', 'Is Filled'],
    'options': {
      placeholder: true,
      placeholderText: '',
      require: true,
      rangeFields: {
        lowerEndScaleText: 'Not likely at all',
        higherEndScaleText: 'Extremely likely',
        minScaleValue: npsScale.MIN,
        maxScaleValue: npsScale.MAX
      },
      skins: npsSkins
    }
  },
  {
    'type': questionTypesMap.YES_NO,
    'question': 'Do you agree to the terms and conditions?',
    'label': 'Yes/No',
    'fa_icon': 'fa fa-toggle-on',
    'material_icon': 'toggle_on',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': '',
    'skin': _.find(yesNoSkins, {id: yesNoSkinIds.DEFAULT}),
    'hide_title': true,
    'state': ['Is Equal To', 'Is Not Equal To',],
    'nonQualifying': { Yes: false, No: false },
    'nonQualifyingSettings': { enabled: true, message: '', fullScreen: false },
    'options': {
      placeholder: false,
      placeholderText: '',
      require: true,
      skins: yesNoSkins
    }
  },
  {
    'type': questionTypesMap.FILE_UPLOAD,
    'question': 'Upload a file',
    'label': 'File Upload',
    'fa_icon': 'fa fa-file-upload',
    'material_icon': 'file_upload',
    'description': '',
    'field_name': 'file_upload',
    'hide_title': true,
    'state': ['Is Empty', 'Is Filled'],
    'options': {
      placeholder: false,
      placeholderText: '',
      require: true,
      fileUpload: {
        maxFileSize: 1, // Use minimum value as default
        preFilteredFileExtensions: 'pdf,doc,docx,xls,xlsx,csv,txt,rtf,zip,mp3,mp4,avi,jpg,jpeg,png,gif',
        maxNumberOfFiles: 1,
      },
    }
  },
  {
    'type': questionTypesMap.SIGNATURE,
    'question': 'Please provide your signature',
    'label': 'Signature',
    'fa_icon': 'fa fa-pencil',
    'material_icon': 'gesture',
    'description': '',
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': 'signature',
    'skin': _.find(signatureSkins, { id: signatureSkinIds.DRAW }),
    'hide_title': true,
    'state': ['Is Empty', 'Is Filled'],
    'consent': false,
    'signerNameLabel': 'Full Name',
    'signerEmailLabel': 'Email Address',
    'options': {
      placeholder: false,
      placeholderText: '',
      require: true
    }
  },
  {
    'type': questionTypesMap.PAYMENT,
    'question': 'Complete your payment',
    'label': 'Payment',
    'fa_icon': 'fa fa-credit-card',
    'material_icon': 'payment',
    'description': "Payment is deducted as soon as you fill in your details and proceed - even before this form is submitted. Please don't abandon this form after paying; make sure to complete and submit it.",
    'hover_text': '',
    'hover_text_position': 'left',
    'field_name': 'payment',
    'hide_title': true,
    'state': ['Is Paid', 'Is Not Paid'],
    'options': {
      placeholder: false,
      placeholderText: '',
      require: true
    },
    'skin': _.find(paymentSkins, {id: paymentSkinIds.FIXED}),
    'skins': paymentSkins,
    'payment': {
      provider: '',
      paymentConnectionId: null,
      allowPayerProviderChoice: false,
      name: PAYMENT_DEFAULTS.NAME,
      amount: PAYMENT_DEFAULTS.FIXED_AMOUNT,
      currency: PAYMENT_DEFAULTS.CURRENCY,
      products: [createDefaultPaymentProduct('product_1')],
      description: '',
      buttonText: PAYMENT_DEFAULTS.BUTTON_TEXT
    }
  }
]
